

// export const protocol = 'http://'
// export const host = "localhost:8000";

export const protocol = 'https://'
export const host = "live.vidyaportal.com"; //live


export const version = 'V:2.2.0'
// export const url = protocol + host
export const url = protocol + host

// export const OneSignalAppID = '3aa016fb-b951-4c41-9edd-2e246b5187e2'
// export const OneSignalAppID = '3aa016fb-b951-4c41-9edd-2e246b5187e2'
export const RestAPI = 'YWJlOWRjMGQtMzcyZi00ZTRiLWE0MzUtMTM2ODk3YWZjYWM4'

export const Android_URL = "https://play.google.com/store/apps/details?id=com.codedady.vidyaportal"
export const IOS_URL = "https://apps.apple.com/us/app/vidya-portal-study-abroad-app/id6470228263"
